const dateUtil = require('../dateUtil/dateUtil');

export function isClosed(businessHourOverrides, currentUTCDateTime, dispatchType)
{
    businessHourOverrides = businessHourOverrides.filter((businessHourOverride) => businessHourOverride.isOpen == false);
    return isApplicable(businessHourOverrides, currentUTCDateTime, dispatchType);
}

export function isOpen(businessHourOverrides, currentUTCDateTime, dispatchType)
{
    businessHourOverrides = businessHourOverrides.filter((businessHourOverride) => businessHourOverride.isOpen == true);
    return isApplicable(businessHourOverrides, currentUTCDateTime, dispatchType);
}

function isApplicable(businessHourOverrides, currentUTCDateTime, dispatchType)
{
    businessHourOverrides = businessHourOverrides.filter((businessHourOverride) => businessHourOverride.dispatchTypes.length == 0
        || businessHourOverride.dispatchTypes.includes(dispatchType));

    return businessHourOverrides.some(businessHourOverride =>
    {
        return (dateUtil.isSameOrAfter(currentUTCDateTime, businessHourOverride.fromDateTime)
            && dateUtil.isSameOrBefore(currentUTCDateTime, businessHourOverride.toDateTime))
    });
}
